// extracted by mini-css-extract-plugin
export default {"container":"HI-z","dimension":"II-z","dimensionLabels":"JI-z"};